import type { Webhook, WebhookAuthType, WebhookEvent } from 'src/types/webhook'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

interface UpdateWebhookRequest {
  id: string
  name?: string
  url?: string
  enabled: boolean
  authType: WebhookAuthType
  authKey?: string
  authValue?: string
  events: WebhookEvent[]
}

const useUpdateWebhookMutation = () => {
  const account = useAccount()

  return useMutation(
    async (webhookData: UpdateWebhookRequest) => {
      const { id, ...updateData } = webhookData
      const response = await api.put(`/webhooks/account/${account.id}/webhooks/${id}`, updateData)
      return response.data as Webhook
    },
    {
      mutationKey: ['updateWebhook'],
      successMessage: 'Webhook updated successfully',
      errorMessage: 'Failed to update webhook',
      queryKeysToInvalidate: [['getWebhooks', account.id]]
    }
  )
}

export default useUpdateWebhookMutation
